

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import { Formik, Form } from 'formik';
import CustomExcelUpload from '../../../../Components/CustomExcelUpload/CustomExcelUpload';
import { BackHandSharp, Upload } from '@mui/icons-material';
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from '../../../../Components/Table/CustomTable';
import actions from '../../../../ReduxStore/actions';
import CustomInputForm from '../../../../Components/CustomInputLogin/CustomInputForm';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from 'yup';
import { updateDepartmentAction } from '../../../../ReduxStore/Slices/CreateDepartment/updateDepartment';
import axios from 'axios';
import { adminUrl } from '../../../../constants';
import InvalidRowsModal from '../../../../Components/InvalidRowsModal/InvalidRowsModal';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';



const validationSchema = Yup.object().shape({
    departments: Yup.string()
        .trim()
        .when('file', {
            is: (file) => !file, // if file is null or undefined
            then: (schema) => schema.required('Department name is required.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    file: Yup.mixed().nullable(),
});


const Departments = () => {
    const dispatch = useDispatch();
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
    const [responseTableData, setResponseTableData] = useState([]); // State to toggle

    const tableHeadData = ["S.No", "Department", "Actions"];
    const tableData = [
        { departmentId: "3", department: "ASSEMBLY SUPERVISOR" },
        { departmentId: "4", department: "ASSEMBLY SUPERVISOR" },
        { departmentId: "5", department: "ASSEMBLY SUPERVISOR" },
        { departmentId: "6", department: "ASSEMBLY SUPERVISOR" },

    ]


    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("Department"));
    }, [dispatch]);
    const [editData, setEditData] = useState()
    const { updateDepartment } = useSelector((state) => state?.updateDepartment);
    const { createDepartment } = useSelector((state) => state?.createDepartment);
    const { bulkUploadDepartments } = useSelector((state) => state?.bulkUploadDepartments);





    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }

    const [loading, setLoading] = useState(false);



    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)

        if (values?.file === null) {

            const data1 = {
                data: {
                    department_name: values?.departments
                },
                method: editData?.department_id ? "put" : "post",
                apiName: editData?.department_id ? `updateDepartment/${editData?.department_id}` : "createDepartment"
            };
            const responseData = await dispatch(editData?.department_id ? actions.UPDATEDEPARTMENT(data1) : actions.CREATEDEPARTMENT(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Department fetched successfully.") {
                setLoading(false)
                toast.success("Department fetched successfully.")
            } else if (responseData?.payload?.message === "Department updated.") {
                setLoading(false)

                toast.success("Department upadated successfully.")
                setEditData()
                resetForm()
            }
            else {
                setLoading(false)

                toast.error(responseData?.payload?.message)
            }
        } else {
            const formData = new FormData();
            formData.append("file", values?.file);
            console.log(formData, "formData")
            const data1 = {
                data: formData,
                method: "post",
                apiName: "bulkUploadDepartments/bulk"
            };
            const responseData = await dispatch(actions.BULKUPLOADDEPARTMENTS(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Bulk upload successful.") {
                setLoading(false)
                // toast.success("Bulk upload successful.")
                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen(true)

                resetForm()
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }

        }



    }

    // const handleSamplDownload = () => {

    //     window.open(`${adminUrl}downloadDepartmentsSampleExcelFile`);
    // }

    const authToken = localStorage.getItem("authToken")
    const handleSamplDownload = async () => {
        try {
            const response = await fetch(`${adminUrl}downloadDepartmentsSampleExcelFile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`, // Replace with actual token
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Department_Sample.xlsx'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };








    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")


    const { getAllDepartments } = useSelector((state) => state?.getAllDepartments);
    console.log(getAllDepartments, "getAllDepartments")


    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllDepartments"
            };
            const responseData = dispatch(actions.GETALLDEPARTMENTS(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [updateDepartment, createDepartment, bulkUploadDepartments])

    useEffect(() => {

        const tempArr = [];

        getAllDepartments?.data?.map((data, index) => {
            return tempArr.push({
                // id: data?.internship_id,
                id: data?.department_id,
                department_name: data?.department_name
            });
        });
        setRowTableData(tempArr);




    }, [getAllDepartments])




    const { getDepartmentById } = useSelector((state) => state?.getDepartmentById);


    const handleTableEdit = async (id) => {
        setShowExcelUpload(false)
        setLoading(true)
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top


        console.log(id, "idgretoriut")
        const data1 = {
            data: {},
            method: "get",
            apiName: `getDepartmentById/${id}`
        };
        const responseData = await dispatch(actions.GETDEPARTMENTDBYID(data1));
        console.log(responseData, "getDepartmentById")
        if (responseData?.payload?.message === "All Department fetched successfully.") {
            setLoading(false)
            setEditData(responseData?.payload?.data)
        }


    }





    return (
        <Box>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3
                }}
            >
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        {showExcelUpload ? 'Upload Excel' : 'Add Department'}
                    </Typography>
                    <Typography
                        variant='body1'
                        onClick={() => {
                            setShowExcelUpload(!showExcelUpload)
                            setEditData()
                        }}
                        sx={{
                            textAlign: "end",
                            color: 'var(--main-color)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        {showExcelUpload ? <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} /> : <Upload sx={{ mr: 1 }} />}
                        {showExcelUpload ? 'Back to Form' : 'Upload Excel'}
                    </Typography>
                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        departments: editData?.department_name || '',
                        file: null
                    }}
                    validationSchema={validationSchema}

                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    {showExcelUpload ? (
                                        <>
                                            <CustomExcelUpload
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                resetForm={resetForm}
                                            />
                                            {/* <Typography variant='body1'
                                                sx={{
                                                    // borderBottom: "1px solid var(--main-color)",
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >Download & Sample Excel Format</Typography> */}
                                            {/* <a href="/sample.xlsx" download style={{ textDecoration: 'none' }}> */}
                                            <Typography
                                                onClick={handleSamplDownload}
                                                variant="body1"
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >
                                                Download & Sample Excel Format
                                            </Typography>
                                            {/* </a> */}

                                        </>
                                    ) : (
                                        <CustomInputForm
                                            name="departments"
                                            label="Department"
                                            custPlaceholder="Ex.ASSEMPLY"
                                        />
                                    )}
                                </Grid>

                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        disabled={isSubmitting}
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        {editData?.department_id ? "Update" : "Submit"}
                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="Department List"
                            tableEdit={true}
                            tableActions={true}
                            tableSearch={true}
                            handleTableEdit={handleTableEdit}


                        />
                    </Grid>
                </Grid>
            </Box>
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
            <InvalidRowsModal name="department" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />

        </Box>
    );
};

export default Departments;
